export class Observable {
  constructor(name, sync = false, asyncWait = false) {
    this.observers = [];
    this.name = name;
    this.asyncWait = asyncWait;
    this.sync = sync;
  }

  subscribe(func, funcName, priority = undefined) {
    if (!func || !funcName) {
      throw new Error(
        `Observer ${this.name}: requires func and name for subscription`
      );
    }
    //If not already added
    const found = this.observers.find((obj) => obj.funcName === funcName);
    if (!found) {
      this.observers.push({
        funcName,
        func,
        priority: priority === undefined ? this.observers.length + 1 : priority,
      });
      if (this.sync) {
        this.observers =
          this.observers?.sort((a, b) => a.priority - b.priority) || [];
      }
    }
  }

  unsubscribe(funcName) {
    this.observers = this.observers.filter((obj) => obj.funcName !== funcName);
  }

  async notify(...data) {
    if (this.sync) {
      //Notifies each observer one after other sync. Use case - run observers
      //in the order of priority
      for (let observer of this.observers) {
        await observer.func(...data);
      }
    } else if (this.asyncWait) {
      //If observer is setup with asyncWait as true, wait until the observer notify
      //logic is complete. The observers are called async, but we wait until all the
      //observer notification is complete.
      await Promise.allSettled(
        this.observers.map(async (observer) => await observer.func(...data))
      );
    } else {
      //Observers are  notified, since we do not wait the logic in each observer
      // run async.
      this.observers.forEach((observer) => {
        observer.func(...data);
      });
    }
  }
}
